import { Entity } from '../../../models/entities.model';
import { Match, MatchDelegation, MatchDelegationJob } from '../../championship/models/match.model';
import { Relation } from 'src/app/models/relations.model';
// tslint:disable: variable-name

export class Contributor extends Entity {
  role: string;
  crm: string;
  crm_uf: string;
  delegation_seq: number;
}

export class ContributorMatch extends Match {
  match_delegations: MatchDelegation[];
  constructor(o: Partial<ContributorMatch>) {
    super(o);
  }
}

export class ContributorDelegationMatch {
  match: ContributorMatch;
  delegations?: MatchDelegationJob[];
  relations?: Relation[];

  constructor(o: Partial<ContributorDelegationMatch>) {
    if (o.match) { this.match = o.match; }
    if (o.delegations) { this.delegations = o.delegations; }
    if (o.relations) { this.relations = o.relations; }

    if (!(this.match instanceof Match)) {
      this.match = new ContributorMatch(this.match);
    }

    if (this.delegations) {
      this.delegations = this.delegations.map(d => d instanceof MatchDelegationJob ? d : new MatchDelegationJob(d));
    }

    if (this.relations) {
      this.relations = this.relations.map(r => r instanceof Relation ? r : new Relation(r));
    }

  }
}
